import React from 'react';
import styles from './PageHeroHeader.module.css';

const PageHeroHeader = ({
    icon: Icon,
    eyebrow = 'LivePulse workspace',
    title,
    subtitle,
    badge,
    actions,
    className = '',
}) => (
    <header className={`${styles.header} ${className}`}>
        <span className={styles.iconWrap} aria-hidden>
            {Icon && <Icon size={24} />}
        </span>
        <div className={styles.copy}>
            <span className={styles.eyebrow}>{eyebrow}</span>
            <div className={styles.titleRow}>
                <h1 className={styles.title}>{title}</h1>
                {badge}
            </div>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
    </header>
);

export default PageHeroHeader;
